export const addressAutoCompleteEnum = [
  {
    name: 'country',
    label: 'Stát',
    url: 'countries'
  },
  {
    name: 'region',
    label: 'Kraj',
    url: 'regions'
  },
  {
    name: 'county',
    label: 'Okres',
    url: 'counties'
  },
  {
    name: 'municipality',
    label: 'Obec',
    url: 'municipalities'
  },
  {
    name: 'municipalityPart',
    label: 'Část obce',
    url: 'municipalityparts'
  },
  {
    name: 'street',
    label: 'Ulice',
    url: 'streets'
  }
];

export const addressInputEnum = [
  {
    name: 'descriptiveNumber',
    label: 'Číslo popisné'
  },

  {
    name: 'orientationNumber',
    label: 'Číslo orientační'
  },
  {
    name: 'zip',
    label: 'PSČ'
  }
];



// WEBPACK FOOTER //
// ./src/components/form/Address/_addressEnum.ts